import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import moment from "moment";
import _ from "lodash";

export const checkConditions = (allCondition, operatorValue, value) => {
  let flag = false;
  if (operatorValue.length === allCondition.length) {
    operatorValue.forEach((item) => {
      if (item === undefined) {
        flag = true;
      }
    });
  } else {
    flag = true;
  }
  value.forEach((item, idx) => {
    if (
      item === "" &&
      operatorValue[idx] !== "empty" &&
      operatorValue[idx] !== "not-empty" &&
      operatorValue[idx] !== "mine" &&
      operatorValue[idx] !== "not-mine" &&
      operatorValue[idx] !== "today" &&
      operatorValue[idx] !== "not-today" &&
      operatorValue[idx] !== "yesterday" &&
      operatorValue[idx] !== "this-week" &&
      operatorValue[idx] !== "last-week" &&
      operatorValue[idx] !== "this-month" &&
      operatorValue[idx] !== "last-month" &&
      operatorValue[idx] !== "this-year" &&
      operatorValue[idx] !== "$inWorkingTimeUCRM" &&
      operatorValue[idx] !== "$ninWorkingTimeUCRM" &&
      operatorValue[idx] !== "$inWorkingDayUCRM" &&
      operatorValue[idx] !== "$ninWorkingDayUCRM"
    ) {
      flag = true;
    }
    if (
      (operatorValue[idx] === "$nin" && item?.length === 0) ||
      (operatorValue[idx] === "$in" && item?.length === 0)
    ) {
      flag = true;
    }
    if (item === undefined) {
      flag = true;
    }
  });
  return flag;
};

export const setOperatorCondition = (conditions, operatorVal, valueArray) => {
  conditions.forEach((item, idx) => {
    if (Object.keys(item).length > 0)
      if (Object.keys(item && item.value).length === 1) {
        let keys = Object.keys(item.value);

        if (keys[0] !== "$eq" && keys[0] !== "$ne") {
          operatorVal[idx] = keys[0];
        } else if (keys[0] === "$eq" || keys[0] === "$ne") {
          if (item.value["$eq"] === null) {
            operatorVal[idx] = "empty";
          } else if (item.value["$ne"] === null) {
            operatorVal[idx] = "not-empty";
          } else if (item.value["$eq"] === "mine") {
            operatorVal[idx] = "mine";
          } else if (item.value["$ne"] === "mine") {
            operatorVal[idx] = "not-mine";
          } else if (item.value["$ne"] === "today") {
            operatorVal[idx] = "not-today";
          } else {
            if (
              item.value[keys[0]] === "today" ||
              item.value[keys[0]] === "yesterday" ||
              item.value[keys[0]] === "this-week" ||
              item.value[keys[0]] === "last-week" ||
              item.value[keys[0]] === "this-month" ||
              item.value[keys[0]] === "last-month" ||
              item.value[keys[0]] === "this-year"
            ) {
              operatorVal[idx] = item.value[keys[0]];
            } else {
              operatorVal[idx] = keys[0] === undefined ? "" : keys[0];
            }
          }
        }
        if (item.type === "datetime" || item.type === "datetime-local") {
          if (
            item.value[keys[0]] === "today" ||
            item.value[keys[0]] === "yesterday" ||
            item.value[keys[0]] === "this-week" ||
            item.value[keys[0]] === "last-week" ||
            item.value[keys[0]] === "this-month" ||
            item.value[keys[0]] === "last-month" ||
            item.value[keys[0]] === "this-year"
          ) {
            valueArray[idx] = null;
          } else if (item.value[keys[0]]) {
            valueArray[idx] = moment(item.value[keys[0]]);
          } else {
            valueArray[idx] = null;
          }
        }
        if (item.type === "user") {
          if (keys[0] === "$not") {
            valueArray[idx] = item.value[keys[0]]["$regex"];
          } else if (keys[0] !== "$nin" && keys[0] !== "$in") {
            valueArray[idx] = item.value[keys[0]];
          } else {
            axios
              .post(
                BASE_URL_API + "user/load-list-user",
                {
                  user_ids: item.value[keys[0]],
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("setting_accessToken"),
                  },
                }
              )
              .then((res) => {
                let fieldValue = [];
                res.data.data.map((item, idx) => {
                  fieldValue.push(
                    `${item.First_Name} ${item.Middle_Name} ${item.Last_Name}`
                  );
                  return null;
                });
                valueArray[idx] = [...fieldValue];
              })
              .catch((err) => console.log(err));
          }
        } else {
          if (keys[0] === "$not") {
            valueArray[idx] = item.value[keys[0]]["$regex"];
          } else {
            if (
              operatorVal[idx] === "mine" ||
              operatorVal[idx] === "not-mine"
            ) {
              valueArray[idx] = null;
            } else {
              valueArray[idx] = item.value[keys[0]];
            }
          }
        }
      } else if (Object.keys(item && item.value).length > 1) {
        let keys = Object.keys(item.value);
        if (keys[0] === "$gte" && keys[1] === "$lte") {
          operatorVal[idx] = "$between";
        } else {
          operatorVal[idx] = keys[0];
        }
        if (keys[0] === "$gte" && keys[1] === "$lte") {
          valueArray[idx] = [
            moment(item.value[keys[0]]),
            moment(item.value[keys[1]]),
          ];
        } else {
          valueArray[idx] = item.value[keys[0]];
        }
      } else {
      }
  });
  return {
    valueArray: valueArray,
    operatorVal: operatorVal,
  };
};

export const hexToRGBA = (hex, opacity) => {
  hex = hex.replace("#", "");

  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  let alpha = opacity || 1;

  return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
};

export const filterByText = (array, value, type) => {
  const normalizedSearchName = value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return array.filter((person) => {
    const normalizedPersonName = person[type]
      ?.toLowerCase()
      ?.normalize("NFD")
      ?.replace(/[\u0300-\u036f]/g, "");
    return normalizedPersonName?.includes(normalizedSearchName);
  });
};

export const filterByBoolean = (array, value, key) => {
  return array.filter((item) => {
    if (key) {
      return value.includes(item[key]);
    }

    return value.includes(item?.active);
  });
};

export const showConditions = (conditions, fields, listAllUser) => {
  let listCondition = [];

  conditions.forEach((item, idx) => {
    Object.entries(item).forEach(([key, val]) => {
      if (key === "id_field") {
        let found = fields.find((ele) => ele.value === val);
        if (found) {
          listCondition.push({
            name: found.label,
            decimal_separator: _.get(found, "decimal_separator", 3),
          });
        } else {
          listCondition.push({
            name: val,
          });
        }
      }
      if (key === "type") {
        let tempType = {
          type: val,
        };

        if (val === "user") {
          if (Array.isArray(listCondition[idx].condition)) {
            const newCondition = _.map(
              listCondition[idx].condition,
              (idUser) => {
                const user = _.find(listAllUser, (user) => user._id === idUser);
                return user ? user.Full_Name : idUser;
              }
            );
            listCondition[idx] = {
              ...listCondition[idx],
              ...tempType,
              condition: newCondition,
            };
          } else {
            const user = _.find(
              listAllUser,
              (user) => user._id === listCondition[idx].condition
            );
            listCondition[idx] = {
              ...listCondition[idx],
              ...tempType,
              condition: user ? user.Full_Name : listCondition[idx].condition,
            };
          }
        } else {
          listCondition[idx] = {
            ...listCondition[idx],
            ...tempType,
          };
        }
      }
      if (key === "value") {
        let tempObj = {};

        if (Object.keys(val)[0] === "$not") {
          tempObj = {
            equal: "$not",
            condition: val.$not.$regex,
          };
        } else if (Object.keys(val).length > 2) {
          tempObj = {
            equal: Object.keys(val),
            condition: Object.values(val),
          };
        } else {
          tempObj = {
            equal: Object.keys(val)[0],
            condition: Object.values(val)[0],
          };
        }

        listCondition[idx] = {
          ...listCondition[idx],
          ...tempObj,
        };
      }
    });
  });

  listCondition.forEach((item, idx) => {
    if (item.status === "owner") {
      listCondition[idx] = {
        ...listCondition[idx],
        status: "Assign to",
      };
    }

    if (item.condition === null) {
      if (item.equal === "$eq") {
        listCondition[idx] = {
          ...listCondition[idx],
          equal: "Is Empty",
        };
      } else {
        listCondition[idx] = {
          ...listCondition[idx],
          equal: "Is not empty",
        };
      }
    } else if (Array.isArray(item.equal)) {
      listCondition[idx] = {
        ...listCondition[idx],
        equal: "Between",
        condition: item.condition[0] + " - " + item.condition[1],
      };
    } else if (item.condition === "mine") {
      listCondition[idx] = {
        ...listCondition[idx],
        equal: item.equal === "$eq" ? "Mine" : "Not mine",
        condition: null,
      };
    } else {
      switch (item.equal) {
        case "$eq":
          listCondition[idx] = {
            ...listCondition[idx],
            equal: "Equals",
          };
          break;
        case "$ne":
          listCondition[idx] = {
            ...listCondition[idx],
            equal: "Not Equals",
          };
          break;
        case "$lt":
          if (item.type === "date" || item.type === "datetime-local") {
            listCondition[idx] = {
              ...listCondition[idx],
              equal: "Before",
            };
          } else {
            listCondition[idx] = {
              ...listCondition[idx],
              equal: "Less than",
            };
          }
          break;
        case "$lte":
          listCondition[idx] = {
            ...listCondition[idx],
            equal: "Less than or equal",
          };
          break;
        case "$gt":
          if (item.type === "date" || item.type === "datetime-local") {
            listCondition[idx] = {
              ...listCondition[idx],
              equal: "After",
            };
          } else {
            listCondition[idx] = {
              ...listCondition[idx],
              equal: "Greater than",
            };
          }
          break;
        case "$gte":
          listCondition[idx] = {
            ...listCondition[idx],
            equal: "Greater than or equal",
          };
          break;
        case "$regex":
          listCondition[idx] = {
            ...listCondition[idx],
            equal: "Contains",
          };
          break;
        case "$not":
          listCondition[idx] = {
            ...listCondition[idx],
            equal: "Not Contains",
          };
          break;
        case "$in":
          listCondition[idx] = {
            ...listCondition[idx],
            equal: "Is one of",
            condition: listCondition[idx].condition.join(", "),
          };
          break;
        case "$nin":
          listCondition[idx] = {
            ...listCondition[idx],
            equal: "Is not one of",
            condition: listCondition[idx].condition.join(", "),
          };
          break;

        default:
          break;
      }
    }
  });

  return listCondition;
};

export const showNewConditions = (conditions, fields, listAllUser) => {
  let conditionsList = [];

  _.map(conditions, (condition) => {
    let conditionsItem = [];
    _.map(condition, (item, idx) => {
      Object.entries(item).forEach(([key, val]) => {
        if (key === "id_field") {
          let found = fields.find((ele) => ele.value === val);
          if (found) {
            conditionsItem.push({
              name: found.label,
              decimal_separator: _.get(found, "decimal_separator", 3),
            });
          } else {
            conditionsItem.push({
              name: val,
            });
          }
        }
        if (key === "type") {
          let tempType = {
            type: val,
          };

          if (val === "user") {
            if (Array.isArray(conditionsItem[idx].condition)) {
              const newCondition = _.map(
                conditionsItem[idx].condition,
                (idUser) => {
                  const user = _.find(
                    listAllUser,
                    (user) => user._id === idUser
                  );
                  return user ? user.Full_Name : idUser;
                }
              );
              conditionsItem[idx] = {
                ...conditionsItem[idx],
                ...tempType,
                condition: newCondition,
              };
            } else {
              const user = _.find(
                listAllUser,
                (user) => user._id === conditionsItem[idx].condition
              );
              conditionsItem[idx] = {
                ...conditionsItem[idx],
                ...tempType,
                condition: user
                  ? user.Full_Name
                  : conditionsItem[idx].condition,
              };
            }
          } else {
            conditionsItem[idx] = {
              ...conditionsItem[idx],
              ...tempType,
            };
          }
        }
        if (key === "value") {
          let tempObj = {};

          if (Object.keys(val)[0] === "$not") {
            tempObj = {
              equal: "$not",
              condition: val.$not.$regex,
            };
          } else if (Object.keys(val).length > 2) {
            tempObj = {
              equal: Object.keys(val),
              condition: Object.values(val),
            };
          } else {
            tempObj = {
              equal: Object.keys(val)[0],
              condition: Object.values(val)[0],
            };
          }

          conditionsItem[idx] = {
            ...conditionsItem[idx],
            ...tempObj,
          };
        }

        if (key === "label") {
          conditionsItem[idx] = {
            ...conditionsItem[idx],
            label: val,
          };
        }
      });
    });
    conditionsList.push(conditionsItem);
  });

  const resultCondition = conditionsList.map((ele) => {
    ele.forEach((item, idx) => {
      if (item.status === "owner") {
        ele[idx] = {
          ...ele[idx],
          status: "Assign to",
        };
      }

      if (item.condition === null) {
        if (item.equal === "$eq") {
          ele[idx] = {
            ...ele[idx],
            equal: "Is Empty",
          };
        } else {
          ele[idx] = {
            ...ele[idx],
            equal: "Is not empty",
          };
        }
      } else if (Array.isArray(item.equal)) {
        ele[idx] = {
          ...ele[idx],
          equal: "Between",
          condition: item.condition[0] + " - " + item.condition[1],
        };
      } else if (item.condition === "mine") {
        ele[idx] = {
          ...ele[idx],
          equal: item.equal === "$eq" ? "Mine" : "Not mine",
          condition: null,
        };
      } else {
        switch (item.equal) {
          case "$eq":
            ele[idx] = {
              ...ele[idx],
              equal: "Equals",
            };
            break;
          case "$ne":
            ele[idx] = {
              ...ele[idx],
              equal: "Not Equals",
            };
            break;
          case "$lt":
            if (item.type === "date" || item.type === "datetime-local") {
              ele[idx] = {
                ...ele[idx],
                equal: "Before",
              };
            } else {
              ele[idx] = {
                ...ele[idx],
                equal: "Less than",
              };
            }
            break;
          case "$lte":
            ele[idx] = {
              ...ele[idx],
              equal: "Less than or equal",
            };
            break;
          case "$gt":
            if (item.type === "date" || item.type === "datetime-local") {
              ele[idx] = {
                ...ele[idx],
                equal: "After",
              };
            } else {
              ele[idx] = {
                ...ele[idx],
                equal: "Greater than",
              };
            }
            break;
          case "$gte":
            ele[idx] = {
              ...ele[idx],
              equal: "Greater than or equal",
            };
            break;
          case "$regex":
            ele[idx] = {
              ...ele[idx],
              equal: "Contains",
            };
            break;
          case "$not":
            ele[idx] = {
              ...ele[idx],
              equal: "Not Contains",
            };
            break;

          case "$in":
            ele[idx] = {
              ...ele[idx],
              equal: "Is one of",
              condition: ele[idx].condition.join(", "),
            };
            break;
          case "$nin":
            ele[idx] = {
              ...ele[idx],
              equal: "Is not one of",
              condition: ele[idx].condition.join(", "),
            };
            break;

          default:
            break;
        }
      }
    });

    return ele;
  });

  return resultCondition;
};

export const numberWithCommas = (number, decimal_separator) => {
  if (typeof number !== "number") return `Invalid value: ${number}`;
  if (number === 0) {
    return "0";
  } else
    return number
      .toFixed(decimal_separator)
      .toString()
      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
};

export const moveLastToFirst = (arr) => {
  if (arr && arr.length === 0) return arr;
  const lastElement = arr.pop();
  arr.unshift(lastElement);
  return arr;
};
